import { useTranslations } from 'next-intl';
import BgContainer from '@components/BgContainer';

export default function BannerFrontTopFixed() {
  const t = useTranslations('Banners.BannerFrontTopFixed');
  return (
    <BgContainer>
      <div className='max-w-[650px] border-l-2 border-brand pl-4 md:py-2'>
        <h2 className='mb-2 text-2xl'>{t('title')}</h2>
        {t('content')}
      </div>
    </BgContainer>
  );
}
